import * as React from "react";
import FeatureCard from "./FeatureCard";

interface FeaturesSectionProps {}

const FeaturesSection: React.FC<FeaturesSectionProps> = ({}) => {
  const features = [
    {
      title: "همه جا، در هر زمان",
      description:
        "دستیار شما همیشه در کنار شماست؛ فارغ از زمان و مکان، هر موضوعی که در ذهن دارید.",
      icon: "/landing/overview/f1.webp",
      altText: "همه جا، در هر زمان",
    },
    {
      title: "بسیار ساده ، مثل یک پیامرسان",
      description:
        "با رابط کاربری‌ به روانی اپلیکیشن پیام‌رسان محبوبتان، با هوش مصنوعی گفتگو کنید. جابه‌جایی بین دستیار ها به همان اندازه که آسان است، لذت‌بخش نیز هست و دنیایی از قابلیت ها را در اختیار شما قرار میدهد.",
      icon: "/landing/overview/f2.webp",
      altText: "بسیار ساده ، مثل یک پیامرسان",
    },
    {
      title: "چیدمان دلخواه از هوش مصنوعی را بسازید",
      description:
        "به دنیایی وسیع از دستیارهای هوش مصنوعی قدم بگذارید؛ با ابزار ویرایشی ساده و هوشمند، ترکیب دلخواهتان را بسازید – بی‌دردسر، سریع و دقیق.",
      icon: "/landing/overview/f3.webp",
      altText: "چیدمان دلخواه از هوش مصنوعی را بسازید",
    },
    {
      title: "کافی‌ست ببینید تا بفهمید",
      description:
        "وقتی کلمات کم می‌آورند، تصویر دست به کار می‌شود! عکس خود را آپلود کنید و ببینید چگونه فناوری پیشرفته‌ی ما راز تصویر را برایتان آشکار می‌کند.",
      icon: "/landing/overview/f4.webp",
      altText: "کافی‌ست ببینید تا بفهمید",
    },
    {
      title: "گوش بده و حرف بزن",
      description:
        "به‌راحتی گفت‌وگوی صوتی را شروع کنید و لحن صدای دستیار را مطابق سلیقه‌تان تنظیم کنید تا تجربه‌ای شخصی‌تر داشته باشید.",
      icon: "/landing/overview/f5.webp",
      altText: "قابلیت‌های دستیار را ارتقا دهید",
    },
    {
      title: "از قابلیت افزونه ها استفاده کنید",
      description:
        "هوش دستیار خود را با افزونه‌هایی از دنیای جست‌وجو، دانشگاه، امور مالی و بازی ارتقا دهید و قابلیت‌های تازه‌ای را کشف کنید.",
      icon: "/landing/overview/f6.webp",
      altText: "از قابلیت افزونه ها استفاده کنید",
    },
  ];

  return (
    <section
      role="tabpanel"
      id="features-panel"
      aria-labelledby="features-tab"
      dir="rtl"
      className="px-6 py-32 mx-auto my-0 max-w-[1200px]"
    >
<div className="flex flex-col lg:flex-row items-start justify-between bg-black text-white rounded-xl py-16 px-6 lg:px-12 gap-6 lg:gap-8">
  {/* راست: تیتر و دکمه */}
  <div className="flex-1 text-center lg:text-right">
    <h2 className="text-2xl lg:text-3xl font-extrabold leading-loose mb-4">
      از تمام قابلیت‌ها استفاده کنید:<br />
      <span className="text-white font-bold">
        از <span className="text-orange-500">دستیار‌ها</span> تا <span className="text-yellow-400">افزونه‌ها</span>
      </span>
    </h2>
    <div className="mt-6">
      <a href="https://chat.aiqueue.ir/?utm_source_landing&utm_content=hero_get_started">
        <button className="bg-white text-black py-3 px-8 rounded-lg text-base font-bold hover:bg-neutral-200 transition-all w-full lg:w-auto">
          شروع کنید
        </button>
      </a>
    </div>
  </div>

  {/* چپ: متن توضیحی و آمار */}
  <div className="flex-1 flex flex-col gap-4 items-center lg:items-start text-center lg:text-right">
    <p className="text-neutral-300 text-base lg:text-lg leading-loose">
      دستیار هوش مصنوعی شخصی و تیم حرفه‌ای خود را بسازید و به کمک هوش مصنوعی، پروژه‌های خلاقانه، متنی، آموزشی و شغلی خود را پیش ببرید.
      از این پس، یک تیم تخصصی را برای حل چالش‌ها و افزایش بهره‌وری در کنار خود دارید تا در دنیای تکنولوژی بدرخشید. این قابلیتی است
      که AIQ برای شما ایجاد می‌کند.
    </p>

    <div className="flex flex-row justify-center lg:justify-start gap-6">
      <div className="text-center">
        <h4 className="text-cyan-300 text-xl font-extrabold">رایگان</h4>
        <p className="text-neutral-300 text-sm lg:text-base">شروع کنید</p>
      </div>
      <div className="text-center">
        <h4 className="text-pink-500 text-xl font-extrabold">+10</h4>
        <p className="text-neutral-300 text-sm lg:text-base">دستیار</p>
      </div>
      <div className="text-center">
        <h4 className="text-lime-400 text-xl font-extrabold">+12</h4>
        <p className="text-neutral-300 text-sm lg:text-base">افزونه</p>
      </div>
    </div>
  </div>
</div>




      {/* قسمت features که شامل ویژگی‌های دستیارها است */}
      <div className="grid gap-8 grid-cols-[repeat(auto-fit,minmax(300px,1fr))]">
        {features.map((feature) => (
          <FeatureCard
            key={feature.title}
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
            altText={feature.altText}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
